import ComponentHelper from '../../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import MonacoEditor from 'react-monaco-editor';
import AceEditor from 'react-ace';
import './component-editor.css';
import 'brace/mode/graphqlschema';
import 'brace/theme/monokai';
import Spinner from '../../../components/spinner/Spinner';
import RoutingService from '../../../services/RoutingService';
const RS = new RoutingService();

class ComponentEditor extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
	}

	setInitialData = props => {
		this.data = {
			title: `Component Editor`,
			toEdit: props.toEdit,
			animationCls: 'zoomIn',
			editing: this.setupComponent(props.toEdit),
			tabs: this.getEditorTabs(props.toEdit),
			activeTab: props.toEdit.name,
			cmpDetails: {},
			saving: false,
			validJson: true
		};
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
				this.data.cmpDetails = this.cmpDetails;
			});
		}
	}

	setupComponent = cmp => {
		cmp = JSON.parse(JSON.stringify(cmp));
		this.cmpDetails = {
			order: cmp.order,
			cmpQuery: cmp.cmpQuery,
			key: cmp.key,
			name: cmp.name,
			cmpType: cmp.cmpType
		};
		delete cmp.order;
		delete cmp.cmpQuery;
		delete cmp.key;
		delete cmp.name;
		delete cmp.cmpType;
		return JSON.stringify(cmp, undefined, 2);
	};

	componentDidMount() {
		window.addEventListener('resize', this.updateDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimensions);
		this.cmpDetails = null;
	}

	updateDimensions = () => {
		//automaticLayout is an alternative fix but it uses an interval so has very bad performance impact
		if (this.editor && this.editor.domElement) {
			this.editor.layout({ width: this.editor.domElement.offsetWidth - 10, height: this.editor.domElement.offsetHeight });
		}
	};

	onClose = () => {
		this.setData('animationCls', 'zoomOut');
		setTimeout(() => {
			this.props.onClose();
		}, 250);
	};

	switchTab = evt => {
		this.setData('activeTab', evt.currentTarget.dataset.tab);
	};

	getEditorTabs = toEdit => {
		let tabs = [];
		if (toEdit) {
			tabs.push(toEdit.name);
			if (toEdit.cmpQuery) {
				tabs.push('GraphQL');
			}
		}
		return tabs;
	};

	getTabs = () => {
		let tabs = [];
		for (let i = 0; i < this.data.tabs.length; i++) {
			let tab = this.data.tabs[i];
			tabs.push(
				<div
					className={`editor-tab vbox vcenter hcenter ellipse ${this.data.activeTab === tab ? 'active' : ''}`}
					data-tab={tab}
					onClick={this.switchTab}
					key={i}
				>
					{this.data.tabs[i]}
				</div>
			);
		}
		return tabs;
	};

	handleEditorDidMount = editor => {
		this.editor = editor;
	};

	handleEditorChange = newValue => {
		let decorations = this.editor.getModel().getAllDecorations();
		let error = decorations
			.filter(decorations => {
				return decorations.options.className === 'redsquiggly';
			})
			.map(e => e);
		this.observe(() => {
			this.data.editing = newValue;
			this.data.validJson = error.length <= 0;
		});
		setTimeout(() => {
			let decorations = this.editor.getModel().getAllDecorations();
			let error = decorations
				.filter(decorations => {
					return decorations.options.className === 'redsquiggly';
				})
				.map(e => e);
			this.observe(() => {
				this.data.validJson = error.length <= 0;
			});
		}, 1500);
	};

	handleGQLChange = newValue => {
		this.observe(() => {
			this.data.cmpDetails.cmpQuery = newValue;
		});
	};

	saveCmp = () => {
		this.setData('saving', true);
		this.props
			.onSave({ ...JSON.parse(this.data.editing), ...this.data.cmpDetails })
			.then(res => {
				RS.setCurrentConfiguration(res.data);
				RS.showSuccess();
				this.props.onCompleted(res.data);
				this.onClose();
			})
			.catch(err => {
				this.setData('saving', false);
				console.log(err.response.data);
			});
	};

	render() {
		let { isOpen } = this.props;
		let { title, animationCls, editing, validJson, activeTab, toEdit, cmpDetails, saving } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className={`component-editor-modal animated ${animationCls}`}
				overlayClassName="blur-modal-overlay vbox hcenter vcenter"
			>
				{saving && <Spinner height="500px" text="Saving..." />}
				{!saving && (
					<div className="editor-container">
						<div className="editor-header hbox">
							<div className="title grow-1">{title}</div>
							<i className="mdi mdi-close" onClick={this.onClose} />
						</div>
						<div className="tab-ctn hbox vcenter hright">{this.getTabs()}</div>
						<div className="editor-content">
							{activeTab === 'GraphQL' && (
								<AceEditor
									showPrintMargin={false}
									minLines={10}
									className="gql-editor"
									theme="monokai"
									mode={'graphqlschema'}
									fontSize={12}
									value={cmpDetails.cmpQuery}
									width="100%"
									onChange={this.handleGQLChange}
									editorProps={{ $blockScrolling: Infinity }}
								/>
							)}
							{activeTab === toEdit.name && (
								<MonacoEditor
									language="json"
									theme="vs-dark"
									value={editing}
									options={{ folding: true }}
									editorDidMount={this.handleEditorDidMount}
									onChange={this.handleEditorChange}
								/>
							)}
						</div>
						<div className="btn-ctn">
							<button className="btn m-r-20" onClick={this.onClose}>
								Cancel
							</button>
							<button className="btn primary" disabled={!validJson} onClick={this.saveCmp}>
								Save
							</button>
						</div>
					</div>
				)}
			</Modal>
		);
	}
}
export default ComponentEditor;



// WEBPACK FOOTER //
// ./src/views/app-composer/component-editor/ComponentEditor.js